import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { Hooks } from '@grandvisionhq/payments';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../../../operations/fragments/cart-details.js';
import '../../../../operations/fragments/cart-validation-errors.js';
import '../../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../../operations/mutations/add-cart-line-items.js';
import '../../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../../operations/mutations/create-cart.js';
import '../../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../../operations/mutations/create-cart-from-order.js';
import '../../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../../operations/mutations/remove-cart-voucher-codes.js';
import { REMOVE_CART_LINE_ITEMS } from '../../../../operations/mutations/remove-cart-line-items.js';
import '../../../../operations/mutations/update-cart-line-items.js';
import '../../../../operations/mutations/replace-line-item-contact-lenses-bundle-benelux.js';
import '../../../../operations/mutations/recover-inactive-cart.js';
import { GET_CART } from '../../../../operations/queries/get-cart.js';
import '../../../../operations/queries/get-total-line-items.js';
import '../../../../operations/queries/get-cart-estimated-delivery.js';

// This component returns the regular "go to checkout" button if there are no
// unavailable line items. If there are unavailable line items, it removes
// them from the cart before navigating to checkout.
const FixCartButtonContainer = ({ unavailableLineItems , labels , handleCheckoutNavigation , isLoggedIn  })=>{
    const [{ cartId , cartHash  }, { setCartCount  }] = useCartStorage();
    const { isLoggedInExpressCheckoutEnabled  } = useFeatureToggles();
    const { href: hrefWithCartId  } = Hooks.useGoToCheckoutLink(cartId, cartHash, isLoggedInExpressCheckoutEnabled && isLoggedIn);
    const unavailableItemIds = unavailableLineItems === null || unavailableLineItems === void 0 ? void 0 : unavailableLineItems.map(({ id  })=>({
            id
        })
    );
    const hasUnavailableItems = unavailableItemIds === null || unavailableItemIds === void 0 ? void 0 : unavailableItemIds.length;
    const [removeCartItems, { loading  }] = useMutation(REMOVE_CART_LINE_ITEMS, {
        onCompleted: (data)=>{
            var ref;
            // If no line items are left, we don't want to navigate to checkout
            if (!((ref = data.removeCartLineItems.cart) === null || ref === void 0 ? void 0 : ref.lineItems.length)) {
                setCartCount(0);
                return;
            } else {
                var ref1;
                setCartCount((ref1 = data.removeCartLineItems.cart) === null || ref1 === void 0 ? void 0 : ref1.numberOfItems);
            }
            handleCheckoutNavigation && handleCheckoutNavigation();
            // @TODO useLink is not applying query params properly so we are navigating
            // manually for now until fix arrives
            window.location.href = hrefWithCartId;
        },
        update (cache, { data  }) {
            if (data && data.removeCartLineItems.success === true) {
                const newCart = data.removeCartLineItems.cart;
                cache.writeQuery({
                    query: GET_CART,
                    variables: {
                        id: cartId
                    },
                    data: {
                        cart: {
                            cart: newCart,
                            validationErrors: null,
                            failures: null
                        }
                    }
                });
                window.scrollTo(0, 0);
            }
        }
    });
    const removeAndNavigate = React.useCallback((e)=>{
        if (hasUnavailableItems && cartId) {
            e.preventDefault();
            removeCartItems({
                variables: {
                    cartInput: {
                        cartId,
                        lineItems: unavailableItemIds
                    }
                }
            });
        }
    }, [
        removeCartItems,
        cartId,
        unavailableItemIds,
        hasUnavailableItems
    ]);
    return /*#__PURE__*/ React.createElement(Button, {
        isLoading: loading,
        className: "cart-navigation__button",
        "data-t": "cart-go-to-checkout",
        caption: labels.goToCheckout,
        href: hrefWithCartId,
        onClick: hasUnavailableItems ? removeAndNavigate : handleCheckoutNavigation
    });
};

export { FixCartButtonContainer };
//# sourceMappingURL=FixCartButtonContainer.js.map
